import styled from '@xstyled/styled-components';
import React from 'react';
import { shallow } from 'zustand/shallow';
import { select } from '~/lib/select';
import { TrainingState, useTrainingStore } from '~/training/state';
import { useMediaPlayerStore } from './MediaPlayerProvider';
import { MediaPlayerStore } from './MediaPlayerStore';
import { useCanControl } from '~/ui/video-player/useCanControl';

const CaptionContainer = styled.div`
  position: fixed;
  pointer-events: none;
  bottom: 24px;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 xxl;
  z-index: 100;

  @media ((max-width: 580px) and (max-height: 300px)) {
    bottom: 9px;
  }
`;

const Caption = styled.div`
  padding: sm lg;
  background: rgb(0 0 0 / 65%);
  color: #fff;
  font-size: calc(0.8em + 0.5vw);
  z-index: 100;
  text-align: center;

  @media ((max-width: 580px) and (max-height: 300px)) {
    padding: 0px 5px;
    font-size: 8px;
  }
`;

const selector = (s: MediaPlayerStore) => select(s, 'captions', 'status');
const settingsSelector = (s: TrainingState) => select(s, 'subtitles');

export const MediaCaptions = () => {
  const { captions, status } = useMediaPlayerStore(selector, shallow);
  const { subtitles } = useTrainingStore(settingsSelector, shallow);

  const canControl = useCanControl();

  if (!captions.length || !subtitles) return null;

  if (status != 'playing' && status != 'paused') {
    return null;
  }

  return canControl ? (
    <CaptionContainer>
      {captions.map(c => (
        <Caption
          key={c}
          dangerouslySetInnerHTML={{ __html: c }}
          className={'CaptionBox'}
        />
      ))}
    </CaptionContainer>
  ) : null;
};
